class ComponentRingPrice extends HTMLElement {
    constructor() {
      super()
      
      this.apiBase = 'https://la-reserve-api-production.herokuapp.com/api/v1/diamonds/wp/starting-at';
      this.basePrice = parseInt(this.dataset.basePrice) ? parseInt(this.dataset.basePrice) : parseInt(this.dataset.priceInfo * 100);
      this.compareAtPrice = this.dataset.compareAtPrice ? parseInt(this.dataset.compareAtPrice) : 0;      
      this.eng_handles = document.querySelector('#engagement_handles') ? JSON.parse(document.querySelector('#engagement_handles').textContent) : [];
      this.wishlistERB = true;
      this.elFrom = this.querySelector('.from');
      this.elCompareAtPrice = this.querySelector('.compare');
      this.elFinalPrice = this.querySelector('.final');      
      this.diamondCut = this.dataset.cut ? this.dataset.cut : this.getWishlistCut(this.dataset.cutInfo);      

      if (this.compareAtPrice == 0) {
        this.elCompareAtPrice.style.display = 'none';
      } else {
        this.elCompareAtPrice.innerHTML = `$${this.formatMoney(this.compareAtPrice / 100)}`;
      }
      if (this.apiBase !== "" && this.wishlistERB) {
        this.elFrom.style.display = 'none';
        this.elFinalPrice.innerHTML = "Loading..."         
        this.loadFromPrice();
      } else {
        this.elFinalPrice.innerHTML = `$${this.formatMoney(this.basePrice / 100)}`;
      }
    }

    getWishlistCut(cut) {
      if (this.eng_handles[0].handle && this.dataset.urlInfo) {
        if (this.eng_handles[0].handle.find(er => this.dataset.urlInfo.includes(er))) {
          switch (true)  {     
            case (/\/Round/i.test(cut)):
              return 'Round'
            case (/\/Oval/i.test(cut)):
              return 'Oval'
            case (/\/Cushion/i.test(cut)):
              return 'Cushion'
            case (/\/Emerald/i.test(cut)):
              return 'Emerald'
            case (/\/Radiant/i.test(cut)):
              return 'Radiant'
            case (/\/Pear/i.test(cut)):
              return 'Pear'
            default:
              return false
          };
        } else {
          this.wishlistERB = false;
        }
      }       
    }

    async loadFromPrice() {
      var response = await fetch(`${this.apiBase}?active=true&lg=true&sold=false&shape=${this.diamondCut}&per_page=20&page=1&labs=GIA,IGI&c_cut_off=0&max_price=0.00-50.00&sortBy=retail_price&sort=asc&reg_setting_price=5700&disc_setting_price=6000&caratMin=1.01000000&caratMax=4.31000000&colors=D,E,F,G,H,I&clarity=VS1,VS2,VVS1,VVS2&omit=&fav_ids=`);
      if (response.status != 200) {
        this.elFinalPrice.innerHTML = ``;        
        if (!this.diamondCut) {
          this.nextElementSibling.style.display = 'inline-block'
        }
        return;
      }
      const data = await response.json();
      if (data) {
        var fromPrice = parseInt(data) * 100;
        var totalFromPrice = this.basePrice + fromPrice;
        this.elFrom.style.display = 'inline-block';
        this.elFinalPrice.innerHTML = `$${this.formatMoney(totalFromPrice / 100)}`;
      } else {
        this.elFrom.style.display = 'inline-block';
        this.elFinalPrice.innerHTML = `$${this.formatMoney(this.basePrice / 100)}`;
      }
      
    }

    formatMoney(amount) {
      var currencyFormatter = new Intl.NumberFormat({
        style: "currency",
        currency: "USD",
      });
      return currencyFormatter.format(parseFloat(amount));
    }
}
customElements.define('product-ring-price', ComponentRingPrice);